import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DocumentService } from '@app/shared/services/api/document.service';

@Component({
  selector: 'app-quotation-edit-popup',
  template: `
    <div mat-dialog-title>
      <span class="pr-1">{{'Quotation Edit' | translate}} {{id}}</span>
      <a class="pr-1">
        <mat-chip mat-sm-chip color="accent" selected (click)="viewPdf()" matTooltip="View PDF">
          {{'View'|translate}}
        </mat-chip>
      </a>
      <div fxFlex></div>
      <a matTooltip="Close">
        <mat-icon (click)="dialogRef.close()">close</mat-icon>
      </a>
    </div>
    <app-quotation-edit mat-dialog-content [id]="id" [inPopup]="true" (onSubmitted)="dialogRef.close(true)"></app-quotation-edit>`
})
export class QuotationEditPopupComponent implements OnInit {
  public id;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: number },
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<QuotationEditPopupComponent>,
  ) {
    if (this.data.id) {
      this.id = data.id;
    }
  }

  ngOnInit() {
  }

  viewPdf() {
    this.documentService.viewPdf('quotation', this.id);
  }
}
